import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from "../../context/UserContext";
import { buildUserState, safeJwtDecode } from "../../utilities/tokenUtils";

export default function AuthOptions() {
    const { userData, setUserData } = useContext(UserContext);
    const history = useNavigate();

    const register = () => {
        history('/admin/register');
    };
    
    const login = () => history('/admin/login');
    const logout = () => {
        setUserData(buildUserState(undefined));
        localStorage.removeItem("auth-token");
        sessionStorage.removeItem("partial-token");
        sessionStorage.removeItem("setup-token");
        history('/admin/login');
    };
    
    const users = () => history('/admin/users');
    const profileSettings = () => history('/admin/profile');
    const archive = () => history('/archive');

    const decoded = safeJwtDecode(userData.token);
    const userRole = decoded.role ?? null;
    const userDisplayName = decoded.displayName ?? null;
    
    return (
        <nav className="auth-options">
            {
                userData.token ? (
                    <>
                        <button onClick={archive}>Archivo GN4</button>
                        {userRole === 'administrador' ? 
                            <>
                                <button onClick={register}>Registro</button>
                                <button onClick={users}>Usuarios</button>
                            </>  
                        : null}               
                        <button onClick={profileSettings} style={{display: "flex", alignItems: "center"}}>
                            <i className="material-icons notranslate">settings</i>
                        </button>
                        <button onClick={logout}>Desconectarse</button>
                        <h4 className="subtitle">{userDisplayName}</h4>
                    </>
                ):(
                    <>
                        <button onClick={login}>Iniciar sesión</button>
                    </>
                )
            }
        </nav>
    )
}
